import api from '../api';

const path = '/top';

export const buyTopRequest = (values) => {
    api.post(`${path}/buy`, values);
};

export const buyAdvertsRequest = (values) =>
    api.post(`${path}/buy/adverts`, values);
